export default __webpack_public_path__ + "static/media/Miele Logo.8a9d1662.svg";